import React from 'react';
import { SaveOption } from '../SaveDialog.types';
import {
  StatLinkClassProp,
  DataDtm,
} from '../../../utils/externalAnalyticsGM';
import { linkId, uimetadata } from '../../../utils/metadata';

// Save-dialog side image: use saveFormConfig.image when set (per-project), else the
// per-linkId default. Loaded from the public folder (no webpack bundling).
const _saveImage = (uimetadata as { saveFormConfig?: { image?: string } })?.saveFormConfig?.image;
const IMG_MODAL_SIDE = _saveImage ? `assets/${_saveImage}` : `assets/images/${linkId}/enquire_image.jpg`;

interface OptionsViewProps {
  onOptionClick: (option: SaveOption) => void;
  t: (key: string, fallback?: string) => string;
}

// Save-to-Email is hidden for every brand — the channel is no longer supported.
// (1.0 only drops it for Chevrolet, but the requirement here is all models.)
// `saveFormConfig.hiddenOptions` overrides this per project, including with an
// empty array to bring the option back.
const HIDDEN_OPTIONS: SaveOption[] = (
  uimetadata as { saveFormConfig?: { hiddenOptions?: SaveOption[] } }
)?.saveFormConfig?.hiddenOptions ?? ['email'];

const OptionsView: React.FC<OptionsViewProps> = ({ onOptionClick, t }) => {
  const isHidden = (option: SaveOption) => HIDDEN_OPTIONS.includes(option);

  return (
    <>
      <div className="save-dialog__image-container">
        <img src={IMG_MODAL_SIDE} alt="Vehicle" />
      </div>
      <div className="save-dialog__content-wrapper">
        <div className="save-dialog__options">
          {!isHidden('test-drive') && (
            <button
              className={`save-dialog__option-button ${StatLinkClassProp.statbuttonlink}`}
              onClick={() => onOptionClick('test-drive')}
              data-dtm={DataDtm.LeadForms}
            >
              {t(
                'staticTranslations.saveDialog.optionTestDrive',
                'Book a Test Drive'
              )}
            </button>
          )}
          {!isHidden('callback') && (
            <button
              className={`save-dialog__option-button ${StatLinkClassProp.statbuttonlink}`}
              onClick={() => onOptionClick('callback')}
              data-dtm={DataDtm.LeadForms}
            >
              {t(
                'staticTranslations.saveDialog.optionCallback',
                'Request a call Back'
              )}
            </button>
          )}
          {!isHidden('whatsapp') && (
            <button
              className={`save-dialog__option-button ${StatLinkClassProp.statbuttonlink}`}
              onClick={() => onOptionClick('whatsapp')}
              data-dtm={DataDtm.LeadForms}
            >
              {t(
                'staticTranslations.saveDialog.optionWhatsapp',
                'Save to WhatsApp'
              )}
            </button>
          )}
          {!isHidden('email') && (
            <button
              className={`save-dialog__option-button ${StatLinkClassProp.statbuttonlink}`}
              onClick={() => onOptionClick('email')}
              data-dtm={DataDtm.LeadForms}
            >
              {t('staticTranslations.saveDialog.optionEmail', 'Save to Email')}
            </button>
          )}
        </div>
      </div>
    </>
  );
};

export default OptionsView;
